/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesAltLanguage,
  propTypesFAQContent,
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';
import { propTypesCategory } from '../Category/Category.proptypes';
import { propTypesTag } from '../Tag/Tag.proptypes';

export const propTypesWoobinar = {
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    body: PropTypes.shape({}),
    breadcrumb_title: PropTypes.string,
    card_description: PropTypes.string,
    category: PropTypes.shape({
      document: PropTypes.shape(propTypesCategory),
    }),
    description: PropTypes.string,
    discover_title: PropTypes.string,
    discover_topics: PropTypes.arrayOf(
      PropTypes.shape({
        topic: PropTypes.string,
      })
    ),
    event_duration: PropTypes.string,
    faq_content: PropTypes.arrayOf(PropTypes.shape(propTypesFAQContent)),
    illustration: PropTypes.shape(propTypesIllustration),
    intercom_tag_id: PropTypes.number,
    is_past: PropTypes.bool,
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    modal_button_label_default: PropTypes.string,
    modal_button_label_lt: PropTypes.string,
    modal_button_link_default: PropTypes.shape(propTypesLink),
    modal_button_link_lt: PropTypes.shape(propTypesLink),
    modal_text_default: PropTypes.shape(propTypesTextHtml),
    modal_text_lt: PropTypes.shape(propTypesTextHtml),
    newsletter_required: PropTypes.bool,
    optional_fields: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        name_id: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        type: PropTypes.string,
      })
    ),
    publication_date: PropTypes.string,
    referal_datatrack_attribute: PropTypes.string,
    replay_datatrack_attribute: PropTypes.string,
    replay_link: PropTypes.shape(propTypesLink),
    requires_form: PropTypes.bool,
    sessions: PropTypes.arrayOf(
      PropTypes.shape({
        session_date: PropTypes.string,
        session_id: PropTypes.string,
        session_time: PropTypes.string,
      })
    ),
    subscription_datatrack_attribute: PropTypes.string,
    tag_1: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    tag_2: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    tag_3: PropTypes.shape({
      document: PropTypes.shape(propTypesTag),
    }),
    title: PropTypes.shape(propTypesTextHtml),
  }),
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  url: PropTypes.string,
};
